import {ColorSchemeType} from 'platform/components';

import {TestDriveState} from '@dms/api/sales';
import i18n from '@dms/i18n';

export const TEST_DRIVE_STATE_LABEL_MAP: Record<TestDriveState, string> = {
  planned: i18n.t('entity.testDrive.labels.planned'),
  completed: i18n.t('entity.testDrive.labels.completed'),
  cancelled: i18n.t('entity.testDrive.labels.cancelled'),
} as const;

export const TEST_DRIVE_STATE_COLOR_MAP: Record<TestDriveState, ColorSchemeType> = {
  planned: 'orange',
  completed: 'green',
  cancelled: 'red',
} as const;
